const EmptySelect = () => {
  return (
    <div className="w-full text-center p-2">
      <i className="far fa-3x fa-inbox text-gray-300" />
      <div className="text-gray-400 mt-2">No hay datos</div>
    </div>
  );
};

export default EmptySelect;
